webpackJsonp([273550284943575],{

/***/ 436:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/common-energy-corning-glass-announce-partnership/"},"frontmatter":{"title":"Common Energy & Corning Glass Announce Partnership"}}}]}},"pathContext":{"tag":"New York"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-new-york-3803931a22477a0d060a.js